import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';

export interface ScrollToElementLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  targetElement?: HTMLElement;
}

export const ScrollToElementLink: React.FC<ScrollToElementLinkProps> = ({
  children,
  className,
  href,
  targetElement,
}) => {
  const handleOnLinkClick = e => {
    if (targetElement) {
      e.preventDefault();
      window.scrollTo({
        behavior: 'smooth',
        top: targetElement.offsetTop - 200,
      });
      return;
    }

    const hash = e.target.href.split('#')?.[1];
    if (hash) {
      e.preventDefault();
      window.location.hash = hash;
      const element = document.getElementById(hash);
      if (window && window.scrollTo && element) {
        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop - 200,
        });
      }
    }
  };

  return (
    <Link
      className={classNames('inline-block px-2.5 py-1 rounded-sm bg-bzblue-700 text-center text-white', className)}
      href={href}
      onClick={handleOnLinkClick}
    >
      <span className="text-white">{children}</span>
    </Link>
  );
};
